export default __webpack_public_path__ + "static/media/alerta.3bd38b84.png";